export default [
  { label: 'KeyboardSettings', group: true },

  /******************* TODO: 实现保存MAGIC ****************
  { label: 'Keyboard settings (persistent)', width: 'label' },

  {
    name: 'Swap LCtl/Caps',
    code: 'MAGIC_SWAP_CONTROL_CAPSLOCK',
    title: 'Swap Left Control and Caps Lock',
    width: 1500
  },
  {
    name: 'Caps>LCtl',
    code: 'MAGIC_CAPSLOCK_TO_CONTROL',
    title: 'Treat Caps Lock as Left Control',
    width: 1500
  },
  {
    name: 'Swap LAlt/LGUI',
    code: 'MAGIC_SWAP_LALT_LGUI',
    title: 'Swap Left Alt and Left GUI',
    width: 1500
  },
  {
    name: 'Swap RAlt/RGUI',
    code: 'MAGIC_SWAP_RALT_RGUI',
    title: 'Swap Right Alt and Right GUI',
    width: 1500
  },
  {
    name: 'Disable GUI',
    code: 'MAGIC_NO_GUI',
    title: 'Disable the GUI keys (useful when gaming)',
    width: 1500
  },
  {
    name: 'Swap ` with Esc',
    code: 'MAGIC_SWAP_GRAVE_ESC',
    title: 'Swap ` and Escape',
    width: 1500
  },
  {
    name: 'Swap \\ with Bksp',
    code: 'MAGIC_SWAP_BACKSLASH_BACKSPACE',
    title: 'Swap Backslash and Backspace',
    width: 1500
  },
  {
    name: 'NKRO On',
    code: 'MAGIC_HOST_NKRO',
    title: 'Force N-Key Rollover (NKRO) on',
    width: 1500
  },
  {
    name: 'Swap Alt/GUI',
    code: 'MAGIC_SWAP_ALT_GUI',
    title: 'Swap Alt and GUI on both sides (for macOS)',
    width: 1500
  },
  {
    width: 0
  },
  {
    name: 'Rev LCtl/Caps',
    code: 'MAGIC_UNSWAP_CONTROL_CAPSLOCK',
    title: 'Unswap Left Control and Caps Lock',
    width: 1500
  },
  {
    name: 'Rev Caps>LCtl',
    code: 'MAGIC_UNCAPSLOCK_TO_CONTROL',
    title: 'Stop treating Caps Lock as Left Control',
    width: 1500
  },
  {
    name: 'Rev LAlt/LGUI',
    code: 'MAGIC_UNSWAP_LALT_LGUI',
    title: 'Unswap Left Alt and Left GUI',
    width: 1500
  },
  {
    name: 'Rev RAlt/RGUI',
    code: 'MAGIC_UNSWAP_RALT_RGUI',
    title: 'Unswap Right Alt and Right GUI',
    width: 1500
  },
  {
    name: 'Enable GUI',
    code: 'MAGIC_UNNO_GUI',
    title: 'Enable the GUI keys',
    width: 1500
  },
  {
    name: 'Rev ` with Esc',
    code: 'MAGIC_UNSWAP_GRAVE_ESC',
    title: 'Unswap ` and Escape',
    width: 1500
  },
  {
    name: 'Rev \\ with Bksp',
    code: 'MAGIC_UNSWAP_BACKSLASH_BACKSPACE',
    title: 'Unswap Backslash and Backspace',
    width: 1500
  },
  {
    name: 'NKRO Off',
    code: 'MAGIC_UNHOST_NKRO',
    title: 'Force N-Key Rollover (NKRO) off',
    width: 1500
  },
  {
    name: 'Rev Alt/GUI',
    code: 'MAGIC_UNSWAP_ALT_GUI',
    title: 'Unswap Alt and GUI on both sides (for macOS)',
    width: 1500
  },
  {
    name: 'Togg NKRO',
    code: 'MAGIC_TOGGLE_NKRO',
    title: 'Turn NKRO on or off',
    width: 1500
  },

  {
    label: '背光',
    width: 'label'
  },

  {
    name: 'BL Toggle',
    code: 'BL_TOGG',
    title: '切换背光开或关'
  },
  {
    name: 'BL Cycle',
    code: 'BL_STEP',
    title: '循环设置背光亮度'
  },
  {
    name: 'BL On',
    code: 'BL_ON',
    title: '设置背光为最大亮度'
  },
  {
    name: 'BL Off',
    code: 'BL_OFF',
    title: '关闭背光'
  },
  {
    name: 'BL +',
    code: 'BL_INC',
    title: 'Increase 背光亮度'
  },
  {
    name: 'BL -',
    code: 'BL_DEC',
    title: 'Decrease 背光亮度'
  },
  {
    name: 'BL Breath',
    code: 'BL_BRTG',
    title: '切换呼吸灯 mode背光'
  },  // */

  { label: 'RGB Lighting settings', width: 'label' },

  {
    name: 'RGB Toggle',
    code: 'RGB_TOG',
    title: 'Toggle RGB lighting on or off'
  },
  { name: 'RGB Mode +', code: 'RGB_MOD', title: 'Next RGB mode' },
  { name: 'RGB Mode -', code: 'RGB_RMOD', title: 'Previous RGB mode' },
  { name: 'Hue +', code: 'RGB_HUI', title: 'Increase hue' },
  { name: 'Hue -', code: 'RGB_HUD', title: 'Decrease hue' },
  { name: 'Sat +', code: 'RGB_SAI', title: 'Increase saturation' },
  { name: 'Sat -', code: 'RGB_SAD', title: 'Decrease saturation' },
  { name: 'Bright +', code: 'RGB_VAI', title: 'Increase brightness' },
  { name: 'Bright -', code: 'RGB_VAD', title: 'Decrease brightness' },
  { name: 'Effect +', code: 'RGB_SPI', title: 'Increase RGB effect speed' },
  { name: 'Effect -', code: 'RGB_SPD', title: 'Decrease RGB effect speed' },
  { name: 'RGB Mode P', code: 'RGB_M_P', title: 'RGB mode: Plain' },
  { name: 'RGB Mode B', code: 'RGB_M_B', title: 'RGB mode: Breathe' },
  { name: 'RGB Mode R', code: 'RGB_M_R', title: 'RGB mode: Rainbow' },
  { name: 'RGB Mode SW', code: 'RGB_M_SW', title: 'RGB mode: Swirl' },
  { name: 'RGB Mode SN', code: 'RGB_M_SN', title: 'RGB mode: Snake' },
  { name: 'RGB Mode K', code: 'RGB_M_K', title: 'RGB mode: Knight Rider' },
  { name: 'RGB Mode X', code: 'RGB_M_X', title: 'RGB mode: Christmas' },
  { name: 'RGB Mode G', code: 'RGB_M_G', title: 'RGB mode: Gradient' },
  { name: 'Reset RGB', code: 'RGB_RST', title: 'reset RGB state' },

  { label: 'Bluetooth', width: 'label' },

  { name: 'Dev 1', code: 'SYS_BLE_ADV0', title: 'Pair or connect device 1' },
  { name: 'Dev 2', code: 'SYS_BLE_ADV1', title: 'Pair or connect device 2' },
  { name: 'Dev 3', code: 'SYS_BLE_ADV2', title: 'Pair or connect device 3' },
  { name: 'Dev 4', code: 'SYS_BLE_ADV3', title: 'Pair or connect device 4' },
  { name: 'Dev 5', code: 'SYS_BLE_ADV4', title: 'Pair or connect device 5' },
  { width: 500 },
  { name: 'Del Dev 1', code: 'SYS_BLE_DEL0', title: 'Delete device 1' },
  { name: 'Del Dev 2', code: 'SYS_BLE_DEL1', title: 'Delete device 2' },
  { name: 'Del Dev 3', code: 'SYS_BLE_DEL2', title: 'Delete device 3' },
  { name: 'Del Dev 4', code: 'SYS_BLE_DEL3', title: 'Delete device 4' },
  { name: 'Del Dev 5', code: 'SYS_BLE_DEL4', title: 'Delete device 5' },

  { width: 500 },

  { name: 'Disconn', code: 'SYS_BLE_STOP_ADV', title: 'Turn off advertising, disconnect device', width: 1500 },
  { name: 'Del All Dev', code: 'SYS_BLE_DELBNDS', title: 'Delete all paired devices' },
  { name: 'BT Info', code: 'SYS_BLE_INFO', title: 'Output connection info' },

  { label: 'Keyboard Control', width: 'label' },

  { name: 'Disable BT', code: 'SYS_BLE_DIS', title: 'Disable bluetooth (keep advertising on, just disable HID sending)', width: 1250 },
  { name: 'Enable BT', code: 'SYS_BLE_EN', title: 'Enable bluetooth', width: 1250 },
  { name: 'Toggle BT', code: 'SYS_BLE_TOG', title: 'Toggle bluetooth between disable/enable', width: 1250 },
  { width: 500 },
  { name: 'Disable USB', code: 'SYS_USB_DIS', title: 'Disable USB (disable HID sending)', width: 1250 },
  { name: 'Enable USB', code: 'SYS_USB_EN', title: 'Enable USB', width: 1250 },
  { name: 'Toggle USB', code: 'SYS_USB_TOG', title: 'Toggle USB between disable/enable', width: 1250 },

  { width: 1000 },
  { name: 'DFU', code: 'SYS_ENT_DFU', title: 'Enter DFU mode' },
  { name: 'Sleep', code: 'SYS_ENT_SLP', title: 'Enter sleep mode, press G to wake up' },
  { name: 'Reboot', code: 'SYS_REBOOT', title: 'Reboot keyboard', width: 1250 },
  { name: 'voltage', code: 'SYS_BATT_LV', title: 'Output battery voltage', width: 1250 }
];
